<template>
    <div id="image-printer" class="print" :style="{
        width: paper_width + 'mm',
        overflowX: 'hidden'
    }">
        <div v-for="(image, index) in current_job.images" class="left-floated">
            <img :src="image.src" :alt="image.name" @error="image_loaded(index)" @load="image_loaded(index)">
            <div v-if="(index + 1) % current_job.numbers_of_one_page == 0" style="float: none; page-break-before: always; clear: both;break-after: always;page-break-after: always; padding:0;margin:0;"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ImagePrinter",
    props: {
    },
    data() {
        return {
            job_template : {
                note: "Print Job",
                images: [],
                numbers_of_one_page: 1,
                paper_type: "A4",
                width: 210,
                is_image_loaded: false,
                status: "Pending"
            },
            jobs: [],
            current_job: {},
            perform_interval: null,
            is_printing: false
        }
    },
    mounted() {
        this.$bus.$off('add_image_print_job')
        this.$bus.$on('add_image_print_job', (job) => {
            $("div#print").html("")
            let job_template = _.cloneDeep(this.job_template)
            Object.assign(job_template, job)
            console.log("job_template")
            console.log(job_template)
            this.jobs.push(job_template)
            this.perform()
        })

        this.start_perform_interval()
    },
    beforeDestroy() {
        clearInterval(this.perform_interval)
        this.perform_interval = null
    },
    watch: {
        current_job(value) {
            if (value) {
                this.handle_print()
            }
        }
    },
    computed: {
        paper_width() {
            switch (this.current_job.paper_type) {
                case "79x39":
                    var paper_width = 79
                    break
                case "80x40":
                    var paper_width = 80
                    break
                case "60x20":
                    var paper_width = 60
                    break
                case "100x100":
                    var paper_width = 100
                    break
                case "A4":
                    var paper_width = 210
                    break
                case "A5":
                    var paper_width = 210
                    break
                default:
                    var paper_width = this.current_job.paper_type
            }
            return paper_width
        }
    },
    methods: {
        start_perform_interval() {
            this.perform_interval = setInterval(() => {
                this.perform()
            }, 1000)
        },
        url_with_timestamp(url) {
            var rest_url = new RestUrl(url)
            return rest_url.update_query_string("v", Math.floor(Date.now()))
        },
        async perform() {
            for (let pending_job of _.filter(this.jobs, job => job.status == "Pending")) {
                if (_.isEmpty(this.current_job)) {
                    for(let image of pending_job.images) {
                        await new Promise(resolve => {
                            var preload_image = new Image()
                            preload_image.onload = () => {
                                resolve()
                            }
                            preload_image.src = image.src
                        })
                    }

                    await new Promise(resolve => {
                        this.current_job = pending_job

                        this.current_job.status = "Processing"
                        if (this.current_job.images.length == 0) {
                            this.current_job.is_image_loaded = true
                        }

                        resolve()
                    })
                }
            }
        },
        image_loaded(index) {
            if (!_.isEmpty(this.current_job)) {
                this.current_job.images[index].is_loaded = true
                this.current_job.is_image_loaded = _.filter(this.current_job.images, image => {
                    return image.is_loaded
                }).length == this.current_job.images.length

                this.$nextTick(() => {
                    this.handle_print()
                })
            }
        },
        handle_print() {
            if (this.current_job.is_image_loaded) {
                console.log(this.current_job)
                console.log('print')
                this.current_job.status = "Printing"
                if (ENV.VUE_APP_BUILD_ENV == 'electron') {
                    let web_content = BrowserWindow.getFocusedWindow().webContents
                    try {
                        if (!web_content) throw "webContents not found"
                        if (this.is_printing) throw "Current printing"

                        this.is_printing = true
                        let drivers = web_content.getPrinters() || []
                        if (drivers.length == 0) throw "No any printers"
                        // deviceName: drivers[0].name
                        let default_driver = _.findLast(drivers, driver => driver.isDefault) || {}
                        let device_name = (default_driver.name) ? default_driver.name : drivers[0].name
                        let options = {silent: true, deviceName: device_name}
                        console.log(drivers);
                        console.log(options);
                        console.log(web_content);
                        web_content.print(options, (success) => {
                            console.log('Run webContents.print() result = ', success);
                            if (!success) {
                                web_content.executeJavaScript("window.print()")
                            }
                            console.log("finish")
                            this.finish()
                        })

                    } catch (e) {
                        console.log(e);
                        let dialog = require("electron").remote.dialog
                        if (dialog) {
                            dialog.showErrorBox("Error!", e)
                        }
                        web_content.executeJavaScript("window.print()")

                    } finally {
                        setTimeout(() => {
                            console.log('setTimeout(0.5s) run finish');
                            this.finish()
                        }, 500)
                    }
                } else {
                    if (!this.is_printing) {
                        this.is_printing = true
                        window.print()
                    }
                    this.finish()
                }
            }
        },
        finish() {
            this.current_job.status = "Done"
            this.current_job = {}
            this.is_printing = false
            this.$bus.$emit('print_done_signal')
            this.perform()
        }
    },
    components: {
    }
}
</script>

<style scoped>
.left-floated {
    float: left;
}
img {
    vertical-align: top;
    display: inline-block;
}
</style>
